import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Building2, Settings2, LayoutGrid } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { useOffices } from './officesApi';
import { OfficePicker } from './OfficePicker';
import { getSelectedOffice, hasPickedOffice, openOffice } from '../../services/officeSelection';

const Tab = ({ active, onClick, children, testId }) => (
  <button onClick={onClick} data-testid={testId}
    className={`px-3 py-1.5 rounded-full text-sm font-medium whitespace-nowrap transition-colors ${active ? 'bg-white text-slate-900' : 'text-slate-200 hover:bg-white/10'}`}>
    {children}
  </button>
);

export const OfficeGate = ({ children }) => {
  const navigate = useNavigate();
  const { user, practice } = useAuth();
  const { data, open, multi } = useOffices();
  const lockedOffice = user?.role === 'practice_staff' && user?.officeId;
  if (!data) return children;
  if (!multi && !lockedOffice) return children;
  if (lockedOffice) {
    const o = open.find((x) => x.id === user.officeId);
    return (<>
      <div className="bg-slate-900 text-white text-sm px-4 py-2 flex items-center gap-2" data-testid="office-locked-bar"><Building2 className="w-4 h-4" />{o?.name}</div>
      {children}
    </>);
  }
  if (!hasPickedOffice()) return <OfficePicker data={data} practiceName={practice?.name} />;
  const sel = getSelectedOffice();
  return (<>
    <div className="bg-slate-900 px-4 py-2 flex items-center gap-2 overflow-x-auto" data-testid="office-switcher">
      <span className="text-slate-400 text-xs uppercase tracking-wider mr-1">Office</span>
      {open.map((o) => <Tab key={o.id} active={sel === o.id} onClick={() => openOffice(o.id)} testId={`office-tab-${o.id}`}>{o.name}</Tab>)}
      <Tab active={!sel} onClick={() => openOffice('')} testId="office-tab-all"><LayoutGrid className="inline w-3.5 h-3.5 mr-1" />All offices</Tab>
      {user?.role !== 'practice_staff' && (
        <button onClick={() => navigate('/offices')} data-testid="office-admin-btn"
          className="ml-auto text-sm text-emerald-300 hover:text-white flex items-center gap-1 whitespace-nowrap"><Settings2 className="w-4 h-4" />Practice Admin</button>
      )}
    </div>
    {children}
  </>);
};
